import { css } from '@emotion/core';
import { API } from "aws-amplify";
import axios from 'axios';
import OwnerFileList from "containers/owner/OwnerFileList";
import OwnerIndexList from "containers/owner/OwnerIndexList";
import OwnerIndexModal from "containers/owner/OwnerIndexModal";
import OwnerOccupantsList from "containers/owner/OwnerOccupantsList";
import OwnerOriginList from "containers/owner/OwnerOriginList";
import OwnerOriginModal from "containers/owner/OwnerOriginModal";
import OwnerSearchModal from "containers/owner/OwnerSearchModal";
import OwnerTreeList from "containers/owner/OwnerTreeList";
import OwnerTreeModal from "containers/owner/OwnerTreeModal";
import PropertyOwnerList from "containers/property/PropertyOwnerList";
import { s3GetFolderFiles, s3GetURL, s3Upload, s3Delete } from "lib/awsLib";
import Moment from "moment";
import React, { Component } from "react";
import { Alert, Button, Card, Col, Form, ListGroup, Modal, Nav, Row, Tab, Tabs } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LinkContainer } from "react-router-bootstrap";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { PacmanLoader } from 'react-spinners';
import 'react-table/react-table.css';
import '../common/Detail.css';
import AsyncSelect from 'react-select/async-creatable';




const CancelToken = axios.CancelToken;
const source = CancelToken.source();






export default class OwnerDetail extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);
        this.refreshDataSet = this.refreshDataSet.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
        this.toggleOwnerTextModal = this.toggleOwnerTextModal.bind(this)
        this.deleteFile = this.deleteFile.bind(this);

        this.file = null;

        this.state = {
            isLoading: null,
            isDeleting: null,
            modified: false,
            owner: {},
            idList: [],
            previousId: null,
            nextId: null,
            currentIdIndex: null,

            showAlert: false,
            showWarning: false ,
            errorMessage: "",
            ownerKeyDisabled: true,
            owner_id_child: null,
            showPropertyOwnerDialog: false,
            showOwnerIndexDialog: false,
            showOwnerOriginDialog: false,
            showOwnerTreeDialog: false,
            showOwnerTreeChildDialog: false,
            showOwnerSearchDialog: false,
            showDirectors: false,
            propertyOwners: [],
            index: [],
            origins: [],
            tree: [],
            treeChild: [],
            files:[],
            occupants: [],
            text: null,
            showTextModal: false,
            propertyidlist: [],
            OwnerReviewFilter: { Ownerid: this.props.match.params.id },
            addressFilter: { propertyid: -1 },
            ownerFilter: { propertyid: -1 },

            selectedSuburb: null,
            selectedPostalSuburb: null,
            selectedSalutation: null,
            selectedPosition: null,

            selectedPropertyOwnerIndex: null,

            showStreetAddressCountryFreetextField: false,
            selectedCountryFreetext: null,
            showPostalAddressCountryFreetextField: false,
            selectedPostalCountryFreetext: null,

            suburbOptions: [],
            countryOptions: [],
            countryCodeOptions: [],
            salutationOptions: [],
            positionOptions: [],
            companySearchNotesOptions: [{value: "New owner.", label: "New owner."} ,{value: "Routine.", label: "Routine."},{value: "Must search this update.", label: "Must search this update."},{value: "Search again if a/r lodged.", label: "Search again if a/r lodged."},{value: "Listed company - don't search at ASIC.", label: "Listed company - don't search at ASIC."}],

            property_key: this.props.match.params.propertyid,
            property_id: null,
            owner_id: null,
            origin_db: null,
            origin_owner_id: null,
            owner_name: null,
            care_of: null,
            premises_xx: null,
            building_name_xx: null,
            stno_xx: null,
            street_xx: null,
            address_line_1 : null,
            address_line_2: null,
            suburb: null,
            postcode: null,
            state: null,
            country: null,
            p_care_of: null,
            p_address: null,
            p_suburb: null,
            p_postcode: null,
            p_state: null,
            p_country: null,
            owner_text: null,
            date_last_search: null,
            date_next_search: null,
            acn: null,
            search_notes: null,
            notes: null,
            alternate_text: null,
            contact_email: null,
            contact_first_name: null,
            contact_middle_initial: null,
            contact_notes: null,
            contact_position: null,
            contact_salutation: null,
            contact_surname: null,
            contact_telephone: null,
            email: null,
            exclude_from_mailings: null,
            fax: null,
            internet: null,
            telephone: null,
            search_file_name: null,
            dir_name_1: null,
            dir_name_2: null,
            rp_roll_back: null,
            created_date: null,
            created_by: null,
            last_edited_date: null,
            last_edited_by: null,
            is_company: null
            
        };



       

    }

    componentWillReceiveProps(prevProps) {
        
        if (prevProps.location.pathname !== this.props.location.pathname) {
            // Clean component and reload? 
            console.log("Resetting");
            window.location.reload();
        }
    }

    componentWillUnmount() {
        source.cancel();
        this.setState({ Owner: [] });
        this.setState({ suburbOptions: [] });
       
        
    }


    async componentDidMount() {
       
        try {
            this.setState({ isLoading: true });   
            if (this.props.location.state){
                if (this.props.location.state.propertyidlist){
                    this.setState({propertyidlist: this.props.location.state.propertyidlist});
                }
            }

            if (this.props.location.state){
                if (this.props.location.state.data){
                    //If coming from a lease list do some prep work for the previous and next buttons
                    
                    const idList = this.props.location.state.data;
                    
                    var currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id,10));
    
                    let nextId = null;
                    let previousId = null;
                    
                    if (currentIdIndex+1 < idList.length){
                        nextId = idList[currentIdIndex+1];
                        
                    }
                    if (currentIdIndex >0){
                        previousId = idList[currentIdIndex-1];                            
                    }
                    this.setState({idList: idList,nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex});
                    
                }
                if (this.props.location.state.propertyidlist){
                    this.setState({propertyidlist: this.props.location.state.propertyidlist});
                }


                if (this.props.location.state.previousId){
                    this.setState({previousId: this.props.location.state.previousId});
                }

                if (this.props.location.state.searchHeadOfficeFlag){
                    await this.searchHeadOffices();
                    this.setState({searchHeadOfficeFlag: false});
                }

                
            }

            if (this.props.match.params.id === "new") {
                console.log("New Owner");
                this.setState(state => ({ property_id: this.props.location.search.replace("?propertyid=", "") }));

                this.setState(state => ({ exclude_from_mailings: false }));
                this.setState(state => ({ created_date: new Date() }));
                this.setState(state => ({ created_by: this.props.user }));
                
                this.setState({ ownerKeyDisabled: false });
                await this.syncroniseState();
                document.title = "New owner for " + this.state.property_key;
            }
            else {
                await this.retrieveOwner();
                if(this.props.location.search.indexOf("?subsidiary")>=0){
                    this.setState(state => ({ owner_id_child: this.props.location.search.replace("?subsidiary=", ""), owner_id_parent: null }));
                }
                if(this.props.location.search.indexOf("?parent")>=0){
                    this.setState(state => ({ owner_id_parent: this.props.location.search.replace("?parent=", ""), owner_id_child: null }));
                }
                this.setState(state => ({ ownerFilter: { ownerid: this.state.owner_id } }))

             

                let files = [];
                if(this.state.search_file_name){
                    try{
                        const files = await this.fetchFiles();
                        this.setState({ files });
                    }
                    catch(e){
                        console.log(e.message);
                    }
                }
                else{
                    await s3GetFolderFiles('asic', this.state.origin_owner_id+".").then(async s3filesNoName => {
                    console.log(s3filesNoName);
                    if(s3filesNoName){
                        for (var i = 0; i < s3filesNoName.length; i++) {
                            let url = await s3GetURL(s3filesNoName[i].key.replace("asic/", ""), 'asic');

                            if (s3filesNoName[i].key!=="asic/") {
                                files.push({ key: s3filesNoName[i].key, url: url });
                            }
                        }
                        this.setState({ files });
                        }
                    
                        
                });
                }
                if(this.state.files.length===0)
                    await s3GetFolderFiles('asic', this.state.origin_owner_id.toLowerCase()+".").then(async s3filesNoName => {
                    console.log(s3filesNoName);
                    if(s3filesNoName){
                        for (var i = 0; i < s3filesNoName.length; i++) {
                            let url = await s3GetURL(s3filesNoName[i].key.replace("asic/", ""), 'asic');

                            if (s3filesNoName[i].key!=="asic/") {
                                files.push({ key: s3filesNoName[i].key, url: url });
                            }
                        }
                        this.setState({ files });
                        }
                    
                        });
                

                

                if(this.state.country){
                    if(this.state.country ==="New Zealand"){
                        this.setState({showDirectors: true});
                    }
                }

                document.title = this.state.owner_name;
                
            }
            
            //Get lookups
            this.setState({selectedCompanySearchNotes: this.state.search_notes });

            if (this.state.suburb!=null)
            {
                this.setState({ selectedSuburb: { value: this.state.suburb+" ("+this.state.state+")", label: this.state.suburb+" ("+this.state.state+")" } });            
            }

            if (this.state.p_suburb!=null){
                this.setState({ selectedPostalSuburb: { value: this.state.p_suburb+" ("+this.state.p_state+")", label: this.state.p_suburb+" ("+this.state.p_state+")" } });
            }
           // await this.getSuburbs();

            
            await this.setState({ selectedCountry :{ value: this.state.country, label: this.state.country } });            
            await this.setState({ selectedPostalCountry : { value: this.state.p_country, label: this.state.p_country } });                    
            this.setState({ selectedSalutation: { value: this.state.contact_salutation, label: this.state.contact_salutation } });            
            this.setState({ selectedPosition: { value: this.state.contact_position, label: this.state.contact_position } });
            

           
            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }

        if (this.state.selectedCountry.value !== null && !this.props.countryOptions.find(c => c.value === this.state.selectedCountry.value)) {
            this.setState({
                selectedCountry: { value: '(Custom)', label: '(Custom)' },
                showStreetAddressCountryFreetextField: true,
                selectedCountryFreetext: this.state.selectedCountry.value
            });
        }
        if (this.state.selectedPostalCountry.value !== null && !this.props.countryOptions.find(c => c.value === this.state.selectedPostalCountry.value)) {
            this.setState({
                selectedPostalCountry: { value: '(Custom)', label: '(Custom)' },
                showPostalAddressCountryFreetextField: true,
                selectedPostalCountryFreetext: this.state.selectedPostalCountry.value
            });
        }
    }

    searchFileNameToFileList() {
        if (!this.state.search_file_name) return [];

        let files = [];
        try {
            files = JSON.parse(this.state.search_file_name);
        } catch (e) {
            console.error(e);
            console.log('searchFileNameToFileList(): search_file_name is not new-style JSON string; using legacy fallback');
            files = [{ name: this.state.search_file_name }];
        }
        return files;
    }

    async fetchFiles() {
        const fileList = this.searchFileNameToFileList();
        console.log('fetchFiles() file list:', fileList);
        const s3Files = (await Promise.all(fileList.map(async f => await s3GetFolderFiles('asic', `${f.name}.`))))
            .flat(1)
            .filter((v, i, a) => a.findIndex(v2 => (v2.key === v.key)) === i) // Remove duplicates based on s3 key
            .sort((a, b) => new Date(a.lastModified) - new Date(b.lastModified));
        console.log('fetchFiles() s3 files:', s3Files);
        const s3FileUrls = await Promise.all(s3Files.map(async f => {
            const key = f.key.replace('asic/', '');
            const url = await s3GetURL(key, 'asic');
            return {key: f.key, url: url};
        }));
        console.log('fetchFiles() s3 files with urls:', s3FileUrls);
        return s3FileUrls;
    }

    async syncroniseState() {
        const owner = {
            owner_id: this.state.owner_id,
            origin_db: this.state.origin_db,
            origin_owner_id: this.state.origin_owner_id,
            owner_name: this.state.owner_name,
            care_of: this.state.care_of,
            premises_xx: this.state.premises_xx,
            building_name_xx: this.state.building_name_xx,
            stno_xx: this.state.stno_xx,
            street_xx: this.state.street_xx,
            address_line_1: this.state.address_line_1,
            address_line_2: this.state.address_line_2,
            suburb: this.state.suburb,
            postcode: this.state.postcode,
            state: this.state.state,
            country: this.state.country,
            p_care_of: this.state.p_care_of,
            p_address: this.state.p_address,
            p_suburb: this.state.p_suburb,
            p_postcode: this.state.p_postcode,
            p_state: this.state.p_state,
            p_country: this.state.p_country,
            owner_text: this.state.owner_text,
            date_last_search: this.state.date_last_search,
            date_next_search: this.state.date_next_search,
            acn: this.state.acn,
            search_notes: this.state.search_notes,
            notes: this.state.notes,
            alternate_text: this.state.alternate_text,
            contact_email: this.state.contact_email,
            contact_first_name: this.state.contact_first_name,
            contact_middle_initial: this.state.contact_middle_initial,
            contact_notes: this.state.contact_notes,
            contact_position: this.state.contact_position,
            contact_salutation: this.state.contact_salutation,
            contact_surname: this.state.contact_surname,
            contact_telephone: this.state.contact_telephone,
            email: this.state.email,
            exclude_from_mailings: this.state.exclude_from_mailings,
            fax: this.state.fax,
            internet: this.state.internet,
            telephone: this.state.telephone,
            search_file_name: this.state.search_file_name,
            dir_name_1: this.state.dir_name_1,
            dir_name_2: this.state.dir_name_2,
            rp_roll_back: this.state.rp_roll_back,
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by,
            is_company: this.state.is_company
        };

        this.setState({ owner });
    }

    async retrieveOwner() {

    const owner = await this.getOwner();
                
    const {
            owner_id,
            origin_db,
            origin_owner_id,
            owner_name,
            care_of,
            premises_xx,
            building_name_xx,
            stno_xx,
            street_xx,
            address_line_1,
            address_line_2,
            suburb,
            postcode,
            state,
            country,
            p_care_of,
            p_address,
            p_suburb,
            p_postcode,
            p_state,
            p_country,
            owner_text,
            date_last_search,
            date_next_search,
            acn,
            search_notes,
            notes,
            alternate_text,
            contact_email,
            contact_first_name,
            contact_middle_initial,
            contact_notes,
            contact_position,
            contact_salutation,
            contact_surname,
            contact_telephone,
            email,
            exclude_from_mailings,
            fax,
            internet,
            telephone,
            search_file_name,
            dir_name_1,
            dir_name_2,
            rp_roll_back,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by,
            index,
            origins,
            tree,
            tree_child,
            occupants,
            propertyowners,
            is_company} = owner;

this.setState({
    owner,
    owner_id,
    origin_db,
    origin_owner_id,
    owner_name,
    care_of,
    premises_xx,
    building_name_xx,
    stno_xx,
    street_xx,
    address_line_1,
    address_line_2,
    suburb,
    postcode,
    state,
    country,
    p_care_of,
    p_address,
    p_suburb,
    p_postcode,
    p_state,
    p_country,
    owner_text,
    date_last_search,
    date_next_search,
    acn,
    search_notes,
    notes,
    alternate_text,
    contact_email,
    contact_first_name,
    contact_middle_initial,
    contact_notes,
    contact_position,
    contact_salutation,
    contact_surname,
    contact_telephone,
    email,
    exclude_from_mailings,
    fax,
    internet,
    telephone,
    search_file_name,
    dir_name_1,
    dir_name_2,
    rp_roll_back,
    created_date,
    created_by,
    last_edited_date,
    last_edited_by,
    index: (index || []),
    origins: (origins || []),
    tree: (tree || []),
    treeChild: (tree_child ||[]),
    occupants: (occupants || []),
    propertyOwners: (propertyowners || []),
    is_company
});
}

    //Call API

    getOwner() {
        console.log("inside of getOwner");
        return API.get("colin", `/owners/${this.props.match.params.id}`);
    }

    async saveOwner(owner) {
        // They haven't filled out the freetext field yet; DON'T save the country/postal country as-is or else we'll have '(Custom)' in the DB
        if (owner.country === '(Custom)') {
            owner.country = null;
        }
        if (owner.p_country === '(Custom)') {
            owner.p_country = null;
        }
        
        this.setState({ last_edited_by: this.props.user });
        if (this.props.match.params.id === "new" && this.state.owner_id === null) {
            this.setState({ created_by: this.props.user });
            const response =  await API.post("colin", `/owners/new`, { body: owner });
            try {
                return await response;
    
            } catch (error) {
                alert(error+". Please refresh the page (F5) to try again.")
            };
        }
        const response =  API.put("colin", `/owners/${this.state.owner_id}`, { body: owner });
        try {
            return await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
    }


    getProperties(filter) {
        try {
            API.get("colin", "/propertyowners", { 'queryStringParameters': filter }).then((propertyOwners) => {
                if (propertyOwners) {
                    this.setState(state => ({ propertyOwners }));
                }
            });
        }
        catch{
            console.log("Error getting properties");
        }
    }

    getOwnerIndex(filter) {
        try {
            API.get("colin", "/owners/"+this.state.owner_id+"/index", { 'queryStringParameters': filter }).then((index) => {
                if (index) {
                    this.setState(state => ({ index }));
                }
            });
        }
        catch{
            console.log("Error getting owner index");
        }
    }

    getOwnerOrigins(filter) {
        try {
            API.get("colin", "/owners/" + this.state.owner_id + "/origins", { 'queryStringParameters': filter }).then((origins) => {
                if (origins) {
                    this.setState(state => ({ origins }));
                }
            });
        }
        catch{
            console.log("Error getting owner origins");
        }
    }

    getOwnerOccupants(filter) {
        try {
            API.get("colin", "/owners/" + this.state.owner_id + "/occupants", { 'queryStringParameters': filter }).then((occupants) => {
                if (occupants) {
              
                    this.setState(state => ({ occupants }));
                }
            });
        }
        catch{
            console.log("Error getting owner occupants");
        }
    }


    getOwnerTree(filter) {
        try {
            return API.get("colin", "/owners/" + this.state.owner_id + "/tree", { 'queryStringParameters': filter });
        }
        catch{
            console.log("Error getting owner tree");
        }
    }

    getSuburbs() {
        try {
            API.get("colin", `/suburbs`).then((suburbOptions) => {
                if (suburbOptions) {
                    this.setState(state => ({ suburbOptions }));
                }
            });
        }
        catch{
            console.log("Error getting suburbs");
        }
    }



   


    refreshDataSet = async (dataset) => {
        //Get nabers records

    }


    handleFileChange = async event => {
        console.log("inhandleFileChange");

        const existingFiles = this.searchFileNameToFileList();
        const thisFileExists = existingFiles.find(
            f => {
                const fileName = event.target.files[0].name;
                return f.name === fileName.substring(0, fileName.indexOf("."));
            }
        );
        if (thisFileExists) {
            alert('Upload Failed: A file of this name already exists. Please rename the source file and then re-upload.');
            return;
        }

        this.file = event.target.files[0];
        this.setState({ modified: true });
        let search_file_name = JSON.stringify(
            [
                ...existingFiles,
                { name: this.file.name.substring(0, this.file.name.indexOf(".")) }
            ]
        );
        this.setState({ search_file_name }, this.handleBlur);
    }

    deleteFile = async file=>{
        //await s3Delete(file.key);
        console.log(file.key.substring(0,file.key.indexOf(".")).replace("asic/",""));
        const files = [...this.state.files];
        let index =files.map(r=>r.key).indexOf(file.key);
        console.log("File index "+ index);
        files.splice(index,1);
        console.log(files);
        const newFileList = this.searchFileNameToFileList().filter(
            f => f.name !== file.key.substring(0,file.key.indexOf(".")).replace("asic/","")
        );
        console.log('deleteFile() new file list:', newFileList);
        this.setState(
            {
                search_file_name: (newFileList.length === 0) ? null : JSON.stringify(newFileList),
                files: files,
                modified: true
            }, this.handleBlur
        );
        
        
     
    }



    handleEnterCurrentIdIndex = event =>{
        if(event.keyCode === 13 || event.keyCode === 9 ){
           this.handleGoToRecord();
        }
   }
   
   
    handleGoToRecord = event => {
        console.log(this.state.idList.length);
        if(this.state.currentIdIndex>=0 && this.state.currentIdIndex < this.state.idList.length){
            this.props.history.push({pathname:`/owners/${this.state.idList[this.state.currentIdIndex]}`, state:{data: this.state.idList}});
        }
        else{
            alert("Page no not in range.");
        }
    }

    handleCurrentIdIndexChange =event =>{
        const val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({[event.target.id]: val-1});        
    }

    validateRelatedRecord(record, set) {
        //property
        if (set === "owner") {

            // secondly check that UnitSort has been specified if required

            if (!this.state.owner_name) {
                return [false, "ALERT!:Owner name can't be empty."];
            }

            if (!this.state.origin_owner_id) {
                return [false, "ALERT!:Owner Key can't be empty."];
            }

            if (!this.state.owner_id && (this.state.origin_owner_id.indexOf("\"")>=0 || this.state.origin_owner_id.indexOf("\'")>=0 || this.state.origin_owner_id.indexOf(" ")>=0)) {
                return [false, "ALERT!: Key values cannot include space or quote characters. Please edit the Key value to remove any space or quote characters."];
            }

            // if (this.state.acn!==null && this.state.acn.trim() !== "" ) {
                
            //     if (this.state.acn.replace(/\s/g,"").length!==9) {
            //         return [true, "If you are editing an Australian company, the ACN should be 9 digits long. If you are editing a NZ ignore this message. Your edits have been saved either way."];
            //     }
            // }

            
            if (this.state.email) {
                if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    return [false, "The email is not a correct format"];
                }
            }

            if (this.state.contact_email) {
                if (!this.state.contact_email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    return [false, "The email is not a correct format"];
                }
            }
    
            if(this.state.internet){
                if(!this.state.internet.match(/^[\w.-]{3}(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)){
                    return [false, "The url (website) is not a correct format. Please enter www.{}.{}"];
                }

            }
            
            



        }
        if (set === "ownerIndex") {

            

            if (!record.owner_name) {
                return [false, "Owner name can't be empty."];
            }

          





        }

        if (set === "propertyOwners") {

            // secondly check that UnitSort has been specified if required

            if (!record.property_key) {
                return [false, "Enter a Cityscope reference."];
            }


        }

        return [true,""];
    }

    updateTableState(data, set) {
        this.setState({
            [set]: data
        });
        
    }

    async saveRecord(record, endpoint, id) {

        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                if (endpoint != "propertyOwners" ) {
                    return API.post("colin", `/owners/${this.state.owner_id}/${endpoint.replace("treeChild","tree").toLowerCase()}/new`, {
                        body: record
                    });
                }
                else {
                    const result = await API.post("colin", `/${endpoint.toLowerCase()}/new`, {
                        body: record
                    });
                    this.refreshPropertyOwners();
                    return result;
                }
            }
        }
        //If not a new record and updating an existing, perform a put
        if (endpoint != "propertyOwners" ) {
            console.log("saving origins");
            return API.put("colin", `/owners/${this.state.owner_id}/${endpoint.replace("treeChild","tree").toLowerCase()}/${record[id]}`, {
                body: record
            }
            );
        }
        else {
            return API.put("colin", `/${endpoint.toLowerCase()}/${record[id]}`, {
                body: record
            }
            );
        }
    }

    handleACNChange = event => {
        let val = event.target.value.replace(/[^0-9. ]/g, "");
        if(val.replace(/\s/g,"").length%3==0 && val.length<9){
            val=val+" ";
        }
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

    loadOptions = async (inputValue) => {
        if (inputValue.length>=3){
            //We hacked this to use the cityscope as the suburb param to avoid an RFC
        return await API.get("colin", `/suburbs`, { 'queryStringParameters': {cityscope: inputValue}, 'cancelToken': source.token });
        }
        else{
            return [];
        }

    }


    handleSuburbChange = (selectedSuburb) => {
        if (selectedSuburb) {
        this.setState({ selectedSuburb
                        ,suburb: selectedSuburb.suburb 
                        ,state: selectedSuburb.state 
                        , postcode: selectedSuburb.postcode 
                        , modified: true },this.handleBlur);
        }else {
            this.setState({ selectedSuburb: { value: null, label: null },suburb: "", state: "" ,postcode: ""  },this.handleBlur);                     
        }
        

    }
    handleCreateSuburb = (suburb) =>{
        this.setState({  suburb: suburb 
                        , selectedSuburb: {label: suburb, value: suburb}
                        , state: "" 
                        , postcode: "" 
                        , modified: true },this.handleBlur);
    }

    
    
    handleSuburbInputChange = event => {
        this.setState({ suburb: event });
        
        let suburbOptions = [...this.state.suburbOptions];
        suburbOptions.push({
            value: event, label: event
        });
        this.setState(state => ({ suburbOptions }));        
        this.setState(state => ({ selectedSuburb: { value: event, label: event } }));
        this.setState({ modified: true });
    }


    handlePostalSuburbChange = (selectedPostalSuburb) => {
        if (selectedPostalSuburb) {
        this.setState({ selectedPostalSuburb
                        ,p_suburb: selectedPostalSuburb.suburb 
                        ,p_state: selectedPostalSuburb.state 
                        , p_postcode: selectedPostalSuburb.postcode 
                        , modified: true },this.handleBlur);
        }else {
            this.setState({ selectedPostalSuburb: { value: null, label: null },p_suburb: "", p_state: "" ,p_postcode: ""  },this.handleBlur);                     
        }
        

    }
    handleCreatePostalSuburb = (suburb) =>{
        this.setState({  p_suburb: suburb 
                        , selectedPostalSuburb: {label: suburb, value: suburb}
                        , p_state: "" 
                        , p_postcode: "" 
                        , modified: true },this.handleBlur);
    }

    

    handlePostalSuburbInputChange = event => {
        this.setState({ p_suburb: event });

        let suburbOptions = [...this.state.suburbOptions];
        suburbOptions.push({
            value: event, label: event
        });
        this.setState(state => ({ suburbOptions }));
        this.setState(state => ({ selectedPostalSuburb: { value: event, label: event } }));
        this.setState({ modified: true });
    }


    handleCountryChange = (selectedCountry) => {
        this.setState({ showStreetAddressCountryFreetextField: (selectedCountry.value === '(Custom)') });
        this.setState({ modified: true });
        if (selectedCountry) {
            this.setState(state => ({ selectedCountry }));
            this.setState(state => ({ country: selectedCountry.value }));
            if(selectedCountry.value ==="New Zealand"){
                this.setState(state => ({showDirectors: true}));
            }
            else{
                this.setState(state => ({showDirectors: false}));
            }
        }
        else {
            this.setState({ selectedCountry: { value: null, label: null } });
            this.setState({ country: null });
            this.setState(state => ({showDirectors: false}));
        }
       

    }

    handlePostalCountryChange = (selectedPostalCountry) => {
        this.setState({ showPostalAddressCountryFreetextField: (selectedPostalCountry.value === '(Custom)') });
        this.setState({ modified: true });
        if (selectedPostalCountry) {
            this.setState({ selectedPostalCountry });
            this.setState({ p_country: selectedPostalCountry.value });
        }
        else {
            this.setState({ selectedPostalCountry: { value: null, label: null } });
            this.setState({ p_country: null });
        }

    }

    handlePositionChange = (selectedPosition) => {
        if(selectedPosition){
            this.setState({ selectedPosition });
            this.setState({ contact_position: selectedPosition.value });
        }
        else{
            this.setState({ selectedPosition: {value: null, label: null} });
            this.setState({ contact_position: null });
        }
        this.setState({ modified: true });
    }


    handleSalutationChange = (selectedSalutation) => {
        if(selectedSalutation){
            this.setState({ selectedSalutation });
            this.setState({ contact_salutation: selectedSalutation.value });
        }
        else{
            this.setState({ selectedSalutation: {value: null, label: null} });
            this.setState({ contact_salutation: null });

        }
        this.setState({ modified: true });
    }


   

    handleDateChange(date, name) {
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            }); //this.handleBlur
        }
        else {
            this.setState({
                [name]: null
            });
        }
        this.setState({ modified: true }); //this.handleBlur
    }


    


    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true } );
    }

    handlePercentChange = event => {
        let val = event.target.value.replace(/[^0-9.%]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true } );
    }

    handleNumberChange = event => {
        let val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true } );
    }

    handleMoneyChange = event => {
        let val = event.target.value.replace(/[^0-9.,$]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true } );
    }

    handleCheckBoxChange = event => {
       
        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        });
        this.setState({ modified: true },this.handleblBlur);
    }

    handleStreetAddressClear =async event => {
        this.setState({ care_of: "" 
        ,address_line_1: "" 
        ,address_line_2 : "" 
        ,suburb : "" 
        , postcode: ""
        ,state: ""
        ,country: "" 
        ,selectedSuburb: {value: "", label: ""}
        ,selectedCountry: { value: "", label: "" }  
        ,modified: true },
        this.handleBlur);

    }

    handlePostalAddressClear = async event =>  {
        this.setState({ p_care_of: ""
        , p_address: "" 
        , p_suburb: ""
        , p_postcode: ""
        , p_state: "" 
        , p_country: "" 
        , selectedPostalSuburb :{value: "", label: ""}
        , selectedPostalCountry :{ value: "", label: "" }   
        , modified: true },
        this.handleBlur);
    }

    handleAddStreetAddressFromProperty = async event =>{
        console.log("In handleAddStreetAddressFromProperty");
        console.log(this.state.selectedPropertyOwnerIndex);
        if(this.state.propertyOwners.length===1){
            
            this.setState({ address_line_1: (this.state.propertyOwners[0].street_address ||"")
                            ,address_line_2 : "" 
                            ,suburb : (this.state.propertyOwners[0].suburb ||"")
                            , postcode: (this.state.propertyOwners[0].postcode||"")
                            ,state: (this.state.propertyOwners[0].state||"")
                            ,country: "" 
                            ,selectedSuburb: {value: (this.state.propertyOwners[0].suburb||"")+" ("+(this.state.propertyOwners[0].state||"")+")", label: this.state.propertyOwners[0].suburb+" ("+this.state.propertyOwners[0].state+")",}
                            ,selectedCountry: { value: "", label: "" }  
                            ,modified: true },
                            this.handleBlur);
        }
        else if(this.state.propertyOwners.length>1){
            if (this.state.selectedPropertyOwnerIndex!=null){
                console.log("Found a selected address");
                this.setState({ address_line_1: (this.state.propertyOwners[this.state.selectedPropertyOwnerIndex].street_address ||"")
                    ,address_line_2 : "" 
                    ,suburb : (this.state.propertyOwners[this.state.selectedPropertyOwnerIndex].suburb ||"")
                    , postcode: (this.state.propertyOwners[this.state.selectedPropertyOwnerIndex].postcode||"")
                    ,state: (this.state.propertyOwners[this.state.selectedPropertyOwnerIndex].state||"")
                    ,country: "" 
                    ,selectedSuburb: {value: this.state.propertyOwners[this.state.selectedPropertyOwnerIndex].suburb+" ("+this.state.propertyOwners[this.state.selectedPropertyOwnerIndex].state+")", label: this.state.propertyOwners[this.state.selectedPropertyOwnerIndex].suburb+" ("+this.state.propertyOwners[this.state.selectedPropertyOwnerIndex].state+")",}
                    ,selectedCountry: { value: "", label: "" }  
                    ,modified: true },
                    this.handleBlur);
            }
            else{
                this.selectAddress();
            }
        }

        this.setState({ selectedCountryFreetext: null, showStreetAddressCountryFreetextField: false });
    }

    

    async addPropertyRelation(ownerId) {
        let data = [...this.state.propertyOwners];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            property_id: this.state.property_id,
            property_key: this.state.property_key,
            owner_id: ownerId,
            registered_owner: true,
            suppress_address: false,
            suppress_text: false,
            use_alternate_text: false,
            sort_order: 99,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.updateTableState(data, "propertyOwners");
        const result = await this.saveRecord(data[0], "propertyOwners", "property_owner_id");
        if (result.result) {
            data[0].property_owner_id = result.id;
            data[0].new_record = false;
            this.updateTableState(data, "propertyOwners");
        }
        else {
            this.setState({ errorMessage: result.error_message });
            this.setState({ showAlert: true });
        }

        return;
    }
    
    handleRefreshProperties = async event => {
        
        const tree = await this.getOwnerTree(this.state.ownerFilter);
        if (tree) {
            this.setState(state => ({ tree }));
        }
        
    }

    handleBlur = async event => {
        this.setState({selectedPropertyOwnerIndex: null, showAddressSelect: false});
        if (this.state.modified === true) {
            

            if (!this.state.registered_owner) {
                this.setState(state => ({ registered_owner: false}));
            }

            this.setState({ showAlert: false, last_edited_by: this.props.user, showWarning: false });
            const result = await this.syncroniseState();


            const validation = this.validateRelatedRecord(this.state.owner, "owner");
            console.log("Validation 0 - "+validation[0])
            console.log("Validation 1 - "+validation[1])
            if (validation[0] === true) {
                if(validation[1]!==""){
                    this.setState({ errorMessage: validation[1] });
                    this.setState({ showAlert: true });
                }
                try {
                    this.setState(state => ({ modified: false }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true });
                    }
                    console.log("Saving owner");
                    const result = await this.saveOwner(this.state.owner);
                    this.setState({ isLoading: false });
                    if (result.result === false) {
                        this.setState({search_file_name: null});
                        alert(result.error_message);
                    }
                    else {
                        if (result.error_message != null){
                            if(result.error_message != this.state.is_company ){
                                if (result.error_message=="true"){
                                    this.setState({is_company: true, errorMessage:"This owner has been automatically flagged as a company."});
                                    this.setState({ showWarning: true });
                                }else{
                                    this.setState({is_company: false, errorMessage:  "This owner has NOT been flagged as a company."});
                                    this.setState({ showWarning: true });
                                }
                            }
                        }
                        //Upload after the database has checked the file does not exist
                        const folder = "asic";
                        if (this.file) {
                            const attachment = this.file
                                ? await s3Upload(this.file, folder)
                                : null;

                            if (attachment) {
                                let url = await s3GetURL(attachment.replace("asic/", ""), 'asic');
                                let files = this.state.files;
                                files.push({ key: attachment, url: url });
                                this.setState({ files });
                            }
                        }

                        

                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ owner_id: result.id }));
                            //Create relation to property
                            await this.addPropertyRelation(result.id);
                            this.props.history.push("/owners/" + this.state.owner_id);
                        }
                    }



                } catch (e) {
                    alert(e);

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }

        }

    }



    handleDelete = async event => {
        event.preventDefault();
        if (event.detail !== 0) {

            if (this.state.propertyOwners.length==0) {
                
                const confirmed = window.confirm(
                    "Are you sure you want to delete this owner? "
                );

                if (!confirmed) {
                    return;
                }
        
                else {
                    this.setState({ archived_date: new Date() }, () =>
                        this.syncroniseState().then(async () => {
                            const result = await this.saveOwner(this.state.owner);
                            if (result.result === false) {
                                alert(result.error_message);
                            }
                            else {

                                this.props.history.push("/");
                            }
                        }
                        )
                    );

                }
           
            }
            else {
                window.alert("Record cannot be deleted as the owner is linked to properties");
            }
        }
    }


    toggleOwnerSearchDialog = async() => {
        this.setState({
            showOwnerSearchDialog: !this.state.showOwnerSearchDialog
        });
        try {
            const tree = await API.get("colin", "/owners/" + this.state.owner_id + "/tree", { 'queryStringParameters': this.state.ownerFilter });
            if(tree){
                this.setState({tree});
            }
        }
        catch{
            console.log("Error getting owner tree");
        }        
    }

    async refreshPropertyOwners(){
        console.log("refreshPropertyOwners");
        //if(!this.state.showPropertyOwnerDialog){
            await this.getProperties(this.state.ownerFilter);
        //}
    }
    togglePropertyOwnerModal = async () => {
        this.setState({
            showPropertyOwnerDialog: !this.state.showPropertyOwnerDialog
        },this.refreshPropertyOwners);

        

    }

    async titleCase(str) {
        str = str.toLowerCase().split(' ');
        for (var i = 0; i < str.length; i++) {
          str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
        }
        return str.join(' ');
      }
    // COLIN-OWNER-0003 Create Owner Contact from Owner Index
    async addOwnerContactFromIndex(){
        if (!this.state.showOwnerIndexDialog){
            if (this.state.index.length>0 && !this.state.contact_surname){
                // filter (((v2tblOwnersIndex.SUBOWNER_NAME) Not Like "*registered*" 
                // And (v2tblOwnersIndex.SUBOWNER_NAME) Not Like "*estate*" 
                // And (v2tblOwnersIndex.SUBOWNER_NAME) Not Like "*proprietor*") 
                // AND ((InStr([SUBOWNER_NAME],","))<>0))
                
                var filteredOwnerIndexList = this.state.index.filter((a) => { if(a.owner_name.toLowerCase().search(/registered|estate|the$|proprietor|P\/L/gi)==-1 && a.owner_name.search(/,/)>-1){return true;}else{return false;}} )  ;
                if(filteredOwnerIndexList){
                    
                    for(var i =0;i< filteredOwnerIndexList.length;i++){
                        console.log(filteredOwnerIndexList[i].owner_name);
                        let result = filteredOwnerIndexList[i].owner_name.replace("  "," ").match(/(?<surname>[A-z -]*?),( )?(?<firstname>[A-z]*)( )?(?<middleinitial>[A-Z])?/);
                        console.log(result);
                        if (result.groups.firstname.toLowerCase() === 'the'){
                            continue;
                        }
                        if(result.groups.length>0 ){
                            return;
                        }
                        var firstName = await this.titleCase(result.groups.firstname);
                        var middleName = result.groups.middleinitial;
                        var surname = await this.titleCase(result.groups.surname);
                        const confirmed = window.confirm(
                            `This owner has no contact currently, would you like to add first name: ${firstName} ${ middleName? ", middle initial: "+ middleName:"" }, surname: ${surname} as a contact?`
                        );
        
                        if (confirmed ) {            
                            const matchingFirstName = this.props.firstNames.find( ({ first_name }) => first_name === result.groups.firstname )
                            console.log(matchingFirstName);
                            if  (matchingFirstName) {           
                                    this.setState({
                                        contact_salutation:  ((matchingFirstName.gender ==="M") ? 'Mr' : ((matchingFirstName.gender ==="F") ? 'Ms': null)),
                                        selectedSalutation: {value: ((matchingFirstName.gender ==="M") ? 'Mr' : ((matchingFirstName.gender ==="F") ? 'Ms': null)), label : ((matchingFirstName.gender ==="M") ? 'Mr' : ((matchingFirstName.gender ==="F") ? 'Ms': null))} ,
                                        contact_surname: surname, 
                                        contact_first_name: result.groups.firstname, 
                                        contact_middle_initial: middleName? middleName: null,
                                        modified: true }, this.handleBlur);
                                    break;
                            }else{
                                this.setState({
                                    
                                    contact_surname:surname, 
                                    contact_first_name: firstName, 
                                    contact_middle_initial: middleName,
                                    modified: true }, this.handleBlur);
                                break;
                            }
                        }   
                        
                    }
                }
            }
        }
    }

    toggleOwnerIndexModal = async () => {
        this.setState(state => ({
            showOwnerIndexDialog: !this.state.showOwnerIndexDialog
        }),this.addOwnerContactFromIndex);
        
        
        try {
            API.get("colin", "/owners/"+this.state.owner_id+"/index", { 'queryStringParameters': this.state.ownerFilter }).then((index) => {
                if (index) {
                    this.setState(state => ({ index }));
                }
            });
        }
        catch{
            console.log("Error getting owner index");
        }

    }

    toggleOwnerOriginModal = async () => {
        this.setState(state => ({
            showOwnerOriginDialog: !this.state.showOwnerOriginDialog
        }));

        try {
            API.get("colin", "/owners/" + this.state.owner_id + "/origins", { 'queryStringParameters': this.state.ownerFilter }).then((origins) => {
                if (origins) {
                    this.setState(state => ({ origins }));
                }
            });
        }
        catch{
            console.log("Error getting owner origins");
        }

    }

    toggleOwnerTreeModal = async () => {
        this.setState(state => ({
            showOwnerTreeDialog: !this.state.showOwnerTreeDialog
        }));
        console.log("toggleOwnerTreeModal");
        // try {
        //     return API.get("colin", "/owners/" + this.state.owner_id + "/tree", { 'queryStringParameters': this.state.ownerFilter });
        // }
        // catch{
        //     console.log("Error getting owner tree");
        // }

    }

    toggleOwnerTreeChildModal = async () => {
        this.setState(state => ({
            showOwnerTreeChildDialog: !this.state.showOwnerTreeChildDialog
        }));
        console.log("toggleOwnerTreeChildModal");
        // try {
        //     return API.get("colin", "/owners/" + this.state.owner_id + "/tree", { 'queryStringParameters': this.state.ownerFilter });
        // }
        // catch{
        //     console.log("Error getting owner tree");
        // }

    }

    selectAddress(){
        this.setState(state => ({
            showAddressSelect: !this.state.showAddressSelect
        }));
    }

    handleOwnerText = async (event) => {
        event.preventDefault();
        try {
    		API.get("colin", `/owners/${this.state.owner_id}/text`).then((text) => {
    			if (text) {
    				this.setState(state => ({text: text, showTextModal: true }));
    			}
    		});
    	}
    	catch{
    		console.log("Error getting text");
    	}
    }

    toggleOwnerTextModal(){
        this.setState({showTextModal: !this.state.showTextModal});
    }

    render() {
        return (
            <div className="owner">
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        css={css`
                        display: block;
                        margin: 0 auto;
                        border-color: red`}
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                    </div>}

               
                {this.state.showAddressSelect &&
                    <Modal
                        show={this.state.showAddressSelect}
                        onHide={this.selectAddress}
                         size="sm"
                         dialogClassName="modal-small"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Select a Property</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {this.state.propertyOwners && this.state.propertyOwners.map((property,i) => (

                                <ListGroup.Item key={property.property_key} as="a" header={property.property_key}>
                                   <Button type="button" variant="primary"  size="sm" onClick={()=> {this.setState({selectedPropertyOwnerIndex: i, showAddressSelect: false}, this.handleAddStreetAddressFromProperty)}}>Use - {property.property_key} {property.street_address}</Button>
                                </ListGroup.Item>

                            )
                            )
                            }

                        </Modal.Body>
                    </Modal>
                }
                {this.state.showOwnerIndexDialog &&
                    <OwnerIndexModal
                        show={this.state.showOwnerIndexDialog}
                        onClose={this.toggleOwnerIndexModal}
                        filter={this.state.ownerFilter}
                        isAuthenticated={this.props.isAuthenticated}
                    toggleOwnerIndexModal={this.toggleOwnerIndexModal}
                        user={this.props.user}
                        data={this.state.index}
                        updateTableState={this.updateTableState}
                        saveRecord={this.saveRecord}
                        deleteRecord={this.deleteRecord}
                        validateRelatedRecord={this.validateRelatedRecord}
                        ownerid={this.state.owner_id}

                    />
                }

                {this.state.showOwnerOriginDialog &&
                    <OwnerOriginModal
                    show={this.state.showOwnerOriginDialog}
                        onClose={this.toggleOwnerOriginModal}
                        filter={this.state.ownerFilter}
                        isAuthenticated={this.props.isAuthenticated}
                        toggleOwnerOriginModal={this.toggleOwnerOriginModal}
                        user={this.props.user}
                        data={this.state.origins}
                        updateTableState={this.updateTableState}
                        saveRecord={this.saveRecord}
                        deleteRecord={this.deleteRecord}
                        validateRelatedRecord={this.validateRelatedRecord}
                    ownerid={this.state.owner_id}
                    countryCodeOptions={this.props.countryCodeOptions}
                    />
                }

                {this.state.showOwnerTreeDialog &&
                    <OwnerTreeModal
                        show={this.state.showOwnerTreeDialog}
                        onClose={this.toggleOwnerTreeModal}
                        filter={this.state.ownerFilter}
                        isAuthenticated={this.props.isAuthenticated}
                        toggleOwnerTreeModal={this.toggleOwnerTreeModal}
                        user={this.props.user}
                        data={this.state.tree}
                        updateTableState={this.updateTableState}
                        saveRecord={this.saveRecord}
                        deleteRecord={this.deleteRecord}
                        validateRelatedRecord={this.validateRelatedRecord}
                        ownerid={this.state.owner_id}  
                        parentChild="subsidiary"                       
                    />
                }
                {this.state.showOwnerTreeChildDialog &&
                    <OwnerTreeModal
                        show={this.state.showOwnerTreeChildDialog}
                        onClose={this.toggleOwnerTreeChildModal}
                        filter={this.state.ownerFilter}
                        isAuthenticated={this.props.isAuthenticated}
                        toggleOwnerTreeModal={this.toggleOwnerTreeChildModal}
                        user={this.props.user}
                        data={this.state.treeChild}
                        updateTableState={this.updateTableState}
                        saveRecord={this.saveRecord}
                        deleteRecord={this.deleteRecord}
                        validateRelatedRecord={this.validateRelatedRecord}
                        ownerid={this.state.owner_id}         
                        parentChild="parent"             
                    />
                }
                {this.state.showOwnerSearchDialog &&
                
                <OwnerSearchModal
                    isAuthenticated={this.props.isAuthenticated}
                    user={this.props.user}
                    toggleOwnerSearchDialog={this.toggleOwnerSearchDialog}                    
                    show={this.state.showOwnerSearchDialog}
           
                    ownerid={this.state.owner_id}
                    controlType="table3"  


                    />
            }
            {this.state.showTextModal &&
            <Modal
                show={this.state.showTextModal}
                onHide={this.toggleOwnerTextModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Owner Text</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.text[0].owner_text}
                </Modal.Body>
            </Modal>
        }
                {this.state.owner && this.props.isAuthenticated && !this.state.isLoading &&
                    <div className="OwnerForm">
                   {this.state.showWarning &&
                                <Alert variant="warning">{this.state.errorMessage}</Alert>
                            }
                    <Form  >
                        <Form.Row>
                        <Col ><h6>Owner Details - {this.state.owner_name} </h6></Col>

                        
                        {/*
                            <Col md={{ span: 1, offset: 7 }} >
                                <Button
                                    variant="danger"
                                    onClick={this.handleDelete}

                                >Delete</Button>
                            </Col>
                        */}
                        
                            <Col>
                            <Nav className="justify-content-center" >
                                {this.state.previousId!== null && !this.state.owner_id_child && !this.state.owner_id_parent  &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/owners/${this.state.previousId}`, state:{data: this.state.idList, propertyidlist: this.state.propertyidlist}}} >
                                            <Button type="button" variant="info"  size="sm">Previous</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                   
                                    {this.state.nextId!== null && !this.state.owner_id_child && !this.state.owner_id_parent   &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/owners/${this.state.nextId}`, state:{data: this.state.idList, propertyidlist: this.state.propertyidlist}}} >
                                            <Button type="button" variant="info"  size="sm">Next</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                    {this.state.currentIdIndex!==null && !this.state.owner_id_child  && !this.state.owner_id_parent  &&
                                        <Form.Group as={Row} controlId="currentIdIndex" >     
                                        <Col className="zeroPadRight">
                                            <Form.Control
                                                onChange={this.handleCurrentIdIndexChange}
                                                value={this.state.currentIdIndex+1}
                                                as="input"
                                                type="text"
                                                min="0"
                                                className="pageCount"
                                                onBlur={this.handleGoToRecord}
                                                onKeyDown={this.handleEnterCurrentIdIndex}
                                            />
                                            </Col>                               
                                            <Col  className="zeroPadLeft">
                                            <h6><div className="topPad">of {this.state.idList.length} {" "}</div></h6>
                                            </Col>
                                            
                                        </Form.Group>
                                         
                                    }
                                    </Nav>
                            </Col>
                            <Col>
                            <Nav className="justify-content-end " >
                            

                            
                             <Nav.Item>
                                
                                        
                                    
                                        <Button type="button" variant="primary" size="sm" onClick={this.handleOwnerText}>Preview Owner Text</Button>
                                                {" "}
                                             
                                    </Nav.Item>
                                    <Nav.Item  >
                                 <a target="_blank" href="/countries">
                                 <Button
                                     variant="primary"                                  
                                     type="button"
                                     size="sm"
                                 >Add/Edit Countries</Button>{" "}
                                </a>
                                  </Nav.Item>
                                    <Nav.Item  >
                                 <a target="_blank" href="/salutations">
                                 <Button
                                     variant="primary"                                  
                                     type="button"
                                     size="sm"
                                 >Add/Edit Salutations</Button>{" "}
                                </a>
                                  </Nav.Item>
                                  <Nav.Item  >
                                 <a target="_blank" href="/positions">
                                 <Button
                                     variant="primary"                                  
                                     type="button"
                                     size="sm"
                                 >Add/Edit Positions</Button>{" "}
                                </a>
                                  </Nav.Item>
                                  
                             </Nav>
                            </Col>
                        </Form.Row>
                    <Form.Row  id="detail">
                            <Col>
                            <Modal show={this.state.showAlert  && this.state.owner_id? true: false} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                                <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                                <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                            </Modal>
                            {this.state.showAlert && !this.state.owner_id &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                                <Tabs defaultActiveKey={0} id="tabset" onSelect={this.handleRefreshProperties}>

                                <Tab eventKey={0} title="Owner Detail" >
                            <Card id="Ownerdetails"  >
                              
                                
                                    <Card.Body>

                                        
                                    <Form.Row >

                                        <Col sm={12} md={6} lg={3}>
                                            <Card id="col1head1"  >
                                                <Card.Header>Name </Card.Header>

                                                <Card.Body>

                                                        <Form.Group as={Row} controlId="owner_id" >
                                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>ID</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                plaintext readOnly
                                                                value={this.state.owner_id}
                                                                
                                                                type="text"

                                                            />
                                                        </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="origin_owner_id" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Key</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.origin_owner_id}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                    disabled={this.state.ownerKeyDisabled}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="owner_name" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Name</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.owner_name}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="is_company" size="small">
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Owner is a Company</Form.Label>
                                                            <Col><Form.Check
                                                                checked={this.state.is_company}
                                                                onChange={this.handleCheckBoxChange}
                                                                name="is_company"
                                                                type="checkbox"
                                                                onBlur={this.handleBlur}
                                                                tabIndex="-1"
                                                            /></Col>
                                                        </Form.Group>
                                                    </Card.Body>
                                                </Card>
                                                <Card>
                                                    <Card.Header>Street Address</Card.Header>
                                                    <Card.Body>
                                                    
                                                    <Form.Group as={Row} controlId="exclude_from_mailings" size="small">
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Exclude From Mailings</Form.Label>
                                                            <Col><Form.Check
                                                                checked={this.state.exclude_from_mailings}
                                                                onChange={this.handleCheckBoxChange}
                                                                name="exclude_from_mailings"
                                                                type="checkbox"
                                                                onBlur={this.handleBlur}
                                                            /></Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="care_of" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Care Of</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.care_of}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="address_line_1" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Address Line 1</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.address_line_1}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="address_line_2" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Address Line 2</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.address_line_2}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="suburb" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Suburb</Form.Label>
                                                            <Col>
                                                            {/* <CreatableSelect
                                                                        value={this.state.selectedSuburb}
                                                                        onChange={this.handleSuburbChange}
                                                                        options={this.state.suburbOptions}
                                                                    onCreateOption={this.handleSuburbInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    /> */}

                                                            <AsyncSelect                                                                                        
                                                                loadOptions={this.loadOptions}
                                                                value={this.state.selectedSuburb}
                                                                onChange={this.handleSuburbChange}                                                                                       
                                                                onInputChange={this.handleInputChange}
                                                                isClearable
                                                                onCreateOption={this.handleCreateSuburb}
                                                            />
                                                            
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="state" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>State</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onBlur={this.handleBlur}
                                                                    onChange={this.handleChange}
                                                                    value={this.state.state}
                                                                    as="input"
                                                                    type="text"
                                                                    
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="postcode" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postcode</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onBlur={this.handleBlur}
                                                                    onChange={this.handleChange}
                                                                    value={this.state.postcode}
                                                                    as="input"
                                                                    type="text"
                                                                    
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="country" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Country</Form.Label>
                                                            <Col>
                                                            <Select
                                                                    value={this.state.selectedCountry}
                                                                    onChange={this.handleCountryChange}
                                                                    options={this.props.countryOptions.concat([{ value: '(Custom)', label: '(Custom)'}])}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    
                                                                />
                                                                {this.state.showStreetAddressCountryFreetextField && <Form.Control
                                                                    onBlur={this.handleBlur}
                                                                    onChange={this.handleChange}
                                                                    defaultValue={this.state.selectedCountryFreetext}
                                                                    as="input"
                                                                    type="text"
                                                                />}
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Row><Col sm={6} md={6} lg={4}></Col>
                                                        <Col>
                                                        <Button
                                                            variant="secondary"
                                                            onClick={this.handleStreetAddressClear}
                                                            size="sm"
                                                            type="button"
                                                        >Clear</Button>
                                                        </Col>
                                                        <Col>
                                                        <Button
                                                            variant="secondary"
                                                            onClick={this.handleAddStreetAddressFromProperty}
                                                            size="sm"
                                                            type="button"
                                                        >Build from Property</Button>
                                                        </Col>
                                                        </Form.Row>
                                                </Card.Body>
                                            </Card>

                                                <Card>
                                                    <Card.Header>Postal Address</Card.Header>
                                                    <Card.Body>
                                                    <Form.Group as={Row} controlId="exclude_from_mailings" size="small">
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Exclude From Mailings</Form.Label>
                                                            <Col><Form.Check
                                                                checked={this.state.exclude_from_mailings}
                                                                onChange={this.handleCheckBoxChange}
                                                                name="exclude_from_mailings"
                                                                type="checkbox"
                                                                onBlur={this.handleBlur}
                                                            /></Col>
                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="p_care_of" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Care Of</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.p_care_of}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="p_address" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>PO Box</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.p_address}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="p_suburb" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Suburb</Form.Label>
                                                            <Col>
                                                            {/* <CreatableSelect
                                                                        value={this.state.selectedPostalSuburb}
                                                                    onChange={this.handlePostalSuburbChange}
                                                                        options={this.state.suburbOptions}
                                                                    onCreateOption={this.handlePostalSuburbInputChange}
                                                                    onBlur={this.handleBlur}

                                                                    isClearable
                                                                    /> */}

                                                            <AsyncSelect                                                                                        
                                                                loadOptions={this.loadOptions}
                                                                value={this.state.selectedPostalSuburb}
                                                                onChange={this.handlePostalSuburbChange}                                                                                       
                                                                onInputChange={this.handleInputChange}
                                                                isClearable
                                                                onCreateOption={this.handleCreatePostalSuburb}
                                                            />


                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="p_state" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>State</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.p_state}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                    
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="p_postcode" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postcode</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.p_postcode}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                    
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="p_country" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Country</Form.Label>
                                                            <Col>
                                                            <Select
                                                                    value={this.state.selectedPostalCountry}
                                                                    onChange={this.handlePostalCountryChange}
                                                                    options={this.props.countryOptions.concat([{ value: '(Custom)', label: '(Custom)'}])}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    
                                                                />
                                                                {this.state.showPostalAddressCountryFreetextField && <Form.Control
                                                                    onBlur={this.handleBlur}
                                                                    onChange={this.handleChange}
                                                                    defaultValue={this.state.selectedPostalCountryFreetext}
                                                                    as="input"
                                                                    type="text"
                                                                />}
                                                            </Col>

                                                        </Form.Group>
                                                        
                                                         <Form.Row><Col sm={6} md={6} lg={4}></Col>
                                                        <Col>
                                                        <Button
                                                            variant="secondary"
                                                            onClick={this.handlePostalAddressClear}
                                                            size="sm"
                                                        >Clear</Button>
                                                        </Col></Form.Row>

                                                        

                                                    </Card.Body>
                                                </Card>

                                        </Col>


                                        <Col sm={12} md={6} lg={3}>
                                            <Card id="col2head1"  >
                                                <Card.Header>Contact Details </Card.Header>

                                                <Card.Body>

                                                        <Form.Group as={Row} controlId="telephone" >
                                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Telephone</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.telephone}
                                                                as="input"
                                                                    type="tel"
                                                                    onBlur={this.handleBlur}

                                                            />
                                                        </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="fax" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Fax</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.fax}
                                                                    as="input"
                                                                    type="tel"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="internet" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Website</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.internet}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="email" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Email</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.email}
                                                                    as="input"
                                                                    type="email"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="contact_salutation" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Salutation</Form.Label>
                                                            <Col>
                                                                <CreatableSelect
                                                                    value={this.state.selectedSalutation}
                                                                    onChange={this.handleSalutationChange}
                                                                    options={this.props.salutationOptions}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        
                                                        <Form.Group as={Row} controlId="contact_first_name" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>First Name</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_first_name}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="contact_middle_initial" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Middle Initial</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_middle_initial}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="contact_surname" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Surname</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_surname}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="contact_position" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Position</Form.Label>
                                                            <Col>
                                                                <CreatableSelect
                                                                    value={this.state.selectedPosition}
                                                                    onChange={this.handlePositionChange}
                                                                    options={this.props.positionOptions}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="contact_email" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Contact Email</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_email}
                                                                    as="input"
                                                                    type="email"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="contact_telephone" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Contact Telephone</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_telephone}
                                                                    as="input"
                                                                    type="tel"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>


                                                        <Form.Group as={Row} controlId="contact_notes" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Contact Notes</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.contact_notes}
                                                                    as="textarea"
                                                                    rows="3"
                                                                    onBlur={this.handleBlur}
                                                                    bsPrefix="internal"
                                                                />
                                                            </Col>

                                                        </Form.Group>


                                                </Card.Body>
                                            </Card>
                                        </Col>


                                        <Col sm={12} md={6} lg={3}>
                                            <Card id="col3head1"  >
                                                <Card.Header>Owner Text</Card.Header>

                                                <Card.Body>

                                                        <Form.Group as={Row} controlId="owner_text" >
                                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Owner Text</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                onChange={this.handleChange}
                                                                    value={this.state.owner_text}
                                                                    as="textarea"
                                                                    rows="8"
                                                                    onBlur={this.handleBlur}
                                                            />
                                                        </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="alternate_text" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Alternate Text</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.alternate_text}
                                                                    as="textarea"
                                                                    rows="4"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                </Card.Body>
                                                </Card>
                                                <Card  >
                                                    <Card.Header>Company Search</Card.Header>

                                                    <Card.Body>

                                                        <Form.Group as={Row} controlId="date_last_search" >

                                                            <Form.Label className="text-right" column >Last Search</Form.Label>

                                                            <Col>
                                                                <DatePicker
                                                                    selected={this.state.date_last_search? new Date(this.state.date_last_search): null}
                                                                    onChange={e => this.handleDateChange(e, "date_last_search")}
                                                                    className="form-control"
                                                                    
                                                                    onBlur={this.handleBlur}
                                                                    dateFormat="dd/MM/yyyy"
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="date_next_search" >

                                                            <Form.Label className="text-right" column >Next Search</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={this.state.date_next_search? new Date(this.state.date_next_search): null}
                                                                    onChange={e => this.handleDateChange(e, "date_next_search")}
                                                                    
                                                                    className="form-control"
                                                                    onBlur={this.handleBlur}
                                                                    dateFormat="dd/MM/yyyy"
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="acn" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>ACN</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleACNChange}
                                                                    value={this.state.acn}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        
                                                        <div>
                                                        <Form.Group as={Row} controlId="dir_name_1" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Director 1 Name (NZ only)</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.dir_name_1}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                    
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="dir_name_2" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Director 2 Name (NZ only)</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.dir_name_2}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        </div>
                                                        
                                                        <Form.Group as={Row} controlId="search_notes" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Search Notes</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                        defaultValue={this.state.selectedCompanySearchNotes}
                                                                        onChange={this.handleChange}
                                                                        options={this.state.companySearchNotesOptions}
                                                                        as="textarea"
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    bsPrefix="internal"
                                                                    rows={1}
                                                                    />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="search_file_name" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}></Form.Label>
                                                            <Col>
                                                                 <Form.Control
                                                                    onChange={this.handleFileChange}
                                                                    as="input"
                                                                    type="file"
                                                                    onBlur={this.handleBlur} 
                                                                    style={{visibility: "hidden"}}
                                                                /> 
                                                                
                                                                <label htmlFor="search_file_name" className="btn btn-secondary btn-sm">Choose File to Upload</label>
                                                                {/* <input id="search_file_name" style={{visibility: "hidden"}} type="file" onBlur={this.handleBlur} onChange={this.handleFileChange} /> */}
                                                                
                                                            </Col>
                                                            

                                                        </Form.Group>
                                                        
                                                       
                                                       
                                                        <Card>
                                                            <Card.Header> Company Search Extract</Card.Header>
                                                            <Card.Body>
                                                        <OwnerFileList
                                                            isAuthenticated={this.props.isAuthenticated}
                                                            controlType="list"
                                                            data={this.state.files}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            ownerid={this.state.owner_id}
                                                            validateRelatedRecord={this.validateRelatedRecord}
                                                            deleteFile={this.deleteFile}
                                                        />
                                                        </Card.Body>
                                                </Card>
                                                    </Card.Body>
                                                </Card>
                                         
                                                   
                                                    
                                        </Col>


                                        <Col sm={12} md={6} lg={3}>
                                            <Card  >
                                                <Card.Header> Owner Index </Card.Header>

                                                <Card.Body>

                                                        <Button onClick={this.toggleOwnerIndexModal} size="sm" variant="secondary">Edit</Button>
                                                        <OwnerIndexList
                                                            isAuthenticated={this.props.isAuthenticated}
                                                            controlType="list"
                                                            data={this.state.index}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            ownerid={this.state.owner_id}
                                                            validateRelatedRecord={this.validateRelatedRecord}
                                                            
                                                        />

                                                </Card.Body>
                                                </Card>

                                                <Card  >
                                                    <Card.Header> Country of Origin </Card.Header>

                                                    <Card.Body>

                                                        <Button onClick={this.toggleOwnerOriginModal} size="sm" variant="secondary">Edit</Button>
                                                        
                                                        <OwnerOriginList
                                                            isAuthenticated={this.props.isAuthenticated}
                                                            controlType="list"
                                                            data={this.state.origins}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            ownerid={this.state.owner_id}
                                                            validateRelatedRecord={this.validateRelatedRecord}
                                                            countryOptions={this.state.countryOptions}

                                                        />

                                                    </Card.Body>
                                                </Card>
                                                <Card  >
                                                    <Card.Header> Parent Company </Card.Header>

                                                    <Card.Body>
                                                    
                                                        <Button onClick={this.toggleOwnerTreeModal} size="sm" variant="secondary">Edit</Button>{" "}
                                                        <Button
                                                    variant="info"
                                                    onClick={this.toggleOwnerSearchDialog}
                                                    type="button"
                                                    size="sm"
                                                >Search + Add Owner as Parent</Button>
                                                        {this.state.owner_id_child &&
                                                            <LinkContainer to={{pathname:`../owners/${this.state.owner_id_child}`, state: {data: this.state.idList ,propertyidlist: this.state.propertyidlist}}} strict  >
                                                                <Button size="sm" variant="secondary">
                                                                    Return to Subsidiary
                                                                </Button>
                                                            </LinkContainer>
                                                        }
                                                        <OwnerTreeList
                                                            isAuthenticated={this.props.isAuthenticated}
                                                            controlType="list"
                                                            data={this.state.tree}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            ownerid={this.state.owner_id}
                                                            validateRelatedRecord={this.validateRelatedRecord}
                                                            propertyidlist={this.state.propertyidlist}
                                                            idList={this.state.idList}
                                                            parentChild="subsidiary"
                                                        />

                                                    </Card.Body>
                                                </Card>
                                                {this.state.treeChild.length>0 &&
                                                <Card  >
                                                    <Card.Header> Child Company</Card.Header>

                                                    <Card.Body>
                                                    
                                                        <Button onClick={this.toggleOwnerTreeChildModal} size="sm" variant="secondary">Edit</Button>{" "}
                                                        
                                                        {this.state.owner_id_parent &&
                                                            <LinkContainer to={{pathname:`../owners/${this.state.owner_id_parent}`, state: {data: this.state.idList ,propertyidlist: this.state.propertyidlist}}} strict  >
                                                                <Button size="sm" variant="secondary">
                                                                    Return to Parent
                                                                </Button>
                                                            </LinkContainer>
                                                        }
                                                            <OwnerTreeList
                                                                isAuthenticated={this.props.isAuthenticated}
                                                                controlType="list"
                                                                data={this.state.treeChild}
                                                                updateTableState={this.updateTableState}
                                                                saveRecord={this.saveRecord}
                                                                deleteRecord={this.deleteRecord}
                                                                ownerid={this.state.owner_id}
                                                                validateRelatedRecord={this.validateRelatedRecord}
                                                                propertyidlist={this.state.propertyidlist}
                                                                idList={this.state.idList}
                                                                parentChild="parent"
                                                            />

                                                    </Card.Body>
                                                </Card>
                                                }


                                                <Card  >
                                                    <Card.Header> Notes </Card.Header>

                                                    <Card.Body>

                                                        <Form.Group as={Row} controlId="notes" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>General Notes</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.notes}
                                                                    as="textarea"
                                                                    rows="8"
                                                                    onBlur={this.handleBlur}
                                                                    bsPrefix="internal"
                                                                />
                                                            </Col>

                                                        </Form.Group>

                                                    </Card.Body>
                                                </Card>
                                                
                                        </Col>

                                    </Form.Row>

                                        
                                        

                                        
                                    



                                         


                                   






                                </Card.Body>
                            
                        </Card >
                 
                  </Tab>
                
                                
                                
                                    <Tab eventKey={1} title="Properties">
                                        <Card>
                                            <Card.Body>
                                            If you are adding this Owner to or removing this Owner from a Property, please be sure to click through and Preview the Owner Text for that Property.
                                            <PropertyOwnerList
                                                            show={this.state.showPropertyOwnerDialog}
                                                            onClose={this.togglePropertyOwnerModal}
                                                            filter={this.state.ownerFilter}
                                                            isAuthenticated={this.props.isAuthenticated}
                                                            togglePropertyOwnerModal={this.togglePropertyOwnerModal}
                                                            user={this.props.user}
                                                            data={this.state.propertyOwners}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            validateRelatedRecord={this.validateRelatedRecord}
                                                            ownerid={this.state.owner_id}
                                                            controlType="table2"              
                                                            propertyidlist={(this.state.propertyidlist||[])}                                           
                                                        />
                                            </Card.Body>
                                            </Card>
                                    </Tab>
                                    <Tab eventKey={2} title="Occupants">

                                        <Card >
                                            <Card.Body>
                                            <OwnerOccupantsList
                                                            filter={this.state.ownerFilter}
                                                            isAuthenticated={this.props.isAuthenticated}                                                            
                                                            user={this.props.user}
                                                            data={this.state.occupants}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            validateRelatedRecord={this.validateRelatedRecord}
                                                            ownerid={this.state.owner_id}
                                                            controlType="table"              
                                                                                                        
                                                        />
                                            </Card.Body>
                                        </Card>

                                    </Tab>
                                    {/* <Tab eventKey={3} title="Owner search">

                                        <Card >
                                            <Card.Body>
                                                <OwnerSearch
                                                    isAuthenticated={this.props.isAuthenticated}
                                                    user={this.props.user}
                                                    ownerid={this.state.owner_id}
                                                    controlType="table3"
                                                />
                                            </Card.Body>
                                        </Card>
                                    </Tab> */}
                                    <Tab eventKey={12} title="Record History">
                                        <Card style={{ width: '28rem' }}>
                                            <Card.Body>
                                                <Form.Group as={Row} controlId="created_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_date!= null ? Moment(this.state.created_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="created_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_date!= null ? Moment(this.state.last_edited_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                            </Card.Body>
                                        </Card>

                                    </Tab>

                               

                            </Tabs>
                        
                            </Col>
                    </Form.Row>
                    </Form>
                   

                        
                       

                        
                   
                    </div>

                }
            </div>
        );
    }
}